<template>
  <div>
    <div
      v-if="
        questionType != 9 &&
        questionType != 3 &&
        questionType != 1 &&
        questionType != 2 &&
        questionType != 5 &&
        questionType != 6 &&
        questionType != 11 &&
        questionType != 14 &&
        questionType != 18 &&
        questionType != 103 &&
        questionType != 105 &&
        questionType != 101 &&
        questionType != 110 &&
        questionType != 106 &&
        questionType != 107 &&
        questionType != 104 &&
        questionType != 102 &&
        questionType != 117 &&
        questionType != 111 &&
        questionType != 119 &&
        questionType != 124 
      "
    >
      <span style="display: block" v-for="(v, i) in answerItems" :key="i" v-html="getHtml(v)"></span>
    </div>
    <div v-if="row && questionType == 9 && row.questionDetails && row.questionDetails.issue && row.questionDetails.issue.items">
      <p v-for="(v, i) in row.questionDetails.issue.items" :key="i">
        <span v-html="transformHtml(v.content.text)"></span>&nbsp;&nbsp;&nbsp;&nbsp;
        <span class="block" v-html="getHtml(answerItems[i])"></span>
      </p>
    </div>
    <div v-if="questionType == 3">
      <p>
        <span v-for="(v, i) in answerItems" :key="i">
          <span v-html="transformHtml(v.value)"></span>{{ i == answerItems.length - 1 ? '' : '/' }}
        </span>
      </p>
    </div>
    <div v-if="questionType == 1">
      <span style="display: block; display: flex; align-items: center" v-for="(v, i) in answerItems" :key="i">
        <span>{{ getGroupName(v.optionId) ? '【' + getGroupName(v.optionId) + '】' : '' }}</span>
        <span v-html="getRadioHtml(row)"></span>
      </span>
      <!-- <el-image
          v-if="getImg(row)"
          style="width: 30px; height: 30px;"
          :z-index="5000"
          :src="getImg(row)"
          :preview-src-list="[getImg(row)]"
        /> -->
      <show-files
        v-if="row && answerItems && answerItems[0] && answerItems[0].photos"
        :img-data="answerItems[0].photos"
      ></show-files>

      <!-- <div v-if="row && answerItems && answerItems[0] && answerItems[0].photos">
          <el-image
          v-for="(item,index) in answerItems[0].photos"
          :key="index"
          style="width: 30px; height: 30px;"
          :z-index="5000"
          :src="_getDownloadUrl(item)"
          :preview-src-list="[_getDownloadUrl(item)]"
          />
        </div> -->
    </div>
    <div v-if="questionType == 2">
      <div
        v-for="(item, idx) in getAnswer(row, [...row.questionDetails.issue.items, ...getAppendItems(row)])"
        :key="idx"
        style="display: flex; align-items: center; flex-wrap: wrap"
      >
        <span>{{ getGroupName(item[0].id) ? '【' + getGroupName(item[0].id) + '】' : '' }}</span>
        <span v-html="transformHtml(item[0].richText ? item[0].richText : item[0].text)"></span>
        <!-- <el-image
              v-if="item[0].url"
              style="width: 30px; height: 30px;"
              :z-index="5000"
              :src="item[0].url"
              :preview-src-list="[item[0].url]"
            /> -->
        <show-files
          v-if="row && answerItems && answerItems[idx] && answerItems[idx].photos"
          :img-data="answerItems[idx].photos"
        ></show-files>

        <!-- <div v-if="row && answerItems && answerItems[idx] && answerItems[idx].photos">
            <el-image
              v-for="(item,index) in answerItems[idx].photos"
              :key="index"
              style="width: 30px; height: 30px;"
              :z-index="5000"
              :src="_getDownloadUrl(item)"
              :preview-src-list="[_getDownloadUrl(item)]"
            />
          </div> -->
      </div>
    </div>
    <div v-if="questionType == 5" style="display: flex; align-item: center">
      <div>
        <div
          v-for="(item, index) in getAnswer(row, row.questionDetails.issue.rows)"
          :key="index"
          style="display: flex; align-items: center"
        >
          <span
            style="display: block; min-height: 30px"
            v-if="item[0].text"
            v-html="transformHtml(item[0].richText ? item[0].richText : item[0].text)"
          ></span>
          <!-- <el-image
              v-if="item[0].url"
              style="width: 30px; height: 30px;"
              :z-index="5000"
              :src="item[0].url"
              :preview-src-list="[item[0].url]"
            /> -->
        </div>
      </div>
      <div>
        <div
          v-for="(item, index) in getAnswer(row, row.questionDetails.issue.items)"
          :key="index"
          style="display: flex; align-items: center"
        >
          <span
            style="display: block; min-height: 30px"
            v-if="item[0].text"
            v-html="transformHtml(item[0].richText ? item[0].richText : item[0].text)"
          ></span>
          <!-- <el-image
            v-if="item[0].url"
            style="width: 30px; height: 30px;"
            :z-index="5000"
            :src="item[0].url"
            /> -->
        </div>
      </div>
    </div>
    <div v-if="questionType == 6" style="display: flex; align-item: center">
      <div>
        <div
          v-for="(item, index) in getAnswer(row, row.questionDetails.issue.rows)"
          :key="index"
          style="display: flex; align-items: center"
        >
          <span
            style="display: block; min-height: 30px"
            v-if="item[0].text"
            v-html="transformHtml(item[0].richText ? item[0].richText : item[0].text)"
          ></span>
          <!-- <el-image
            v-if="item[0].url"
            style="width: 30px; height: 30px;"
            :z-index="5000"
            :src="item[0].url"
            :preview-src-list="[item[0].url]"
            /> -->
        </div>
      </div>
      <div>
        <div
          v-for="(item, index) in getAnswer(row, row.questionDetails.issue.items)"
          :key="index"
          style="display: flex; align-items: center"
        >
          <span
            style="display: block; min-height: 30px"
            v-if="item[0].text"
            v-html="transformHtml(item[0].richText ? item[0].richText : item[0].text)"
          ></span>

          <!-- <el-image
            v-if="item[0].url"
            style="width: 30px; height: 30px;"
            :z-index="5000"
            :src="item[0].url"
            :preview-src-list="[item[0].url]"
            /> -->
        </div>
      </div>
    </div>
    <div v-if="questionType == 11">
      <div
        v-for="(item, index) in getAnswer(row, row.questionDetails.issue.items)"
        :key="index"
        style="display: flex; align-items: center; line-height: initial; overflow: auto"
      >
        <span v-html="transformHtml(item[0].richText ? item[0].richText : item[0].text)"></span>
        <!-- <el-image
          v-if="item[0].url"
          style="width: 30px; height: 30px;"
          :z-index="5000"
          :src="item[0].url"
          :preview-src-list="[item[0].url]"
        /> -->
      </div>
    </div>
    <!--文件上传题 修改 18-->
    <div v-if="questionType == 18 && row && answerItems">
      <div v-for="(item, index) in answerItems" :key="index">
        <!-- <a :href="_getDownloadUrl(item.value)" :download="item.value">{{ getUrl(item.value) }}</a> -->
        <img
          v-if="isImg(item.value)"
          :src="_getDownloadUrl(item.value)"
          @click="onPreview(index, 2, item)"
          class="mr-1 cursor-pointer"
          style="width: 20px"
        />
        <i v-else class="el-icon-document m-0 mr-1"></i>
        <a :href="isImg(item.value) ? 'javascript:;' : _getDownloadUrl(item.value)" :download="item.value">{{
          ellipsisMiddle(getUrl(item.value), 3, 8)
        }}</a>
        <!-- @click="handleFileEnlarge(item.value)" -->
        <!-- <span v-if="isImg(item.value)" @click="onPreview(index,2,item)" style="color:#227FFE; margin-left:20px; cursor:pointer">预览</span> -->
      </div>
    </div>
    <!-- 矩阵填空 107 / 矩阵下拉题 106 / 兼容旧版101 -->
    <div v-if="questionType === 106 || questionType === 107 || questionType === 101">
      <div class="matrix-scale" v-for="(rowItem, id) of row.questionDetails.issue.rows" :key="id">
        <h4 v-html="transformHtml(rowItem.content.text)" />
        <template v-for="(col, idx) in row.questionDetails.issue.items">
          <div class="flex" :key="idx">
            <h5 v-html="transformHtml(col.content.richText)"></h5>
            <!-- <span v-html="transformHtml(col.content.richText)"></span> -->
            <!-- <h5 class="flex-shrink-0" style="max-width: 120px">
              {{ col.content.text }}
            </h5> -->
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div>{{ getMatrixAnswer(rowItem, col) }}</div>
          </div>
        </template>
      </div>
    </div>
    <!-- 表格组合110 -->
    <div v-if="questionType === 110">
      <div class="matrix-scale" v-for="(rowItem, id) of row.questionDetails.issue.rows" :key="id">
        <h4 v-html="transformHtml(rowItem.content.text)" />
        <template v-for="(col, idx) in row.questionDetails.issue.items">
          <div class="flex" :key="idx">
            <h5 v-html="transformHtml(col.content.richText)"></h5>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div>{{ getMatrixComposeAnswer(rowItem, col) }}</div>
          </div>
        </template>
      </div>
    </div>
    <!-- 手写签名 14 -->
    <div v-if="questionType === 14">
      <el-image
        v-for="(item, index) in answerItems"
        style="width: 30px; height: 30px"
        :z-index="5000"
        :src="_getDownloadUrl(item.value)"
        :preview-src-list="getDownloadList(answerItems, 'value')"
        :key="index"
      />
    </div>
    <!-- 矩阵滑动 103  -->
    <div v-if="questionType === 103">
      <div class="matrix-scroll" v-for="(rowItem, id) of row.questionDetails.issue.items" :key="id">
        <span v-html="transformHtml(rowItem.content.text)"></span>
        <span style="margin-left: 10px"
          >（{{ row.questionDetails.issue.labels[0].num }}-{{ row.questionDetails.issue.labels[1].num }}）</span
        >
        <p>{{ answerItems[id].value }}</p>
      </div>
    </div>
    <!-- 多项填空 105  -->
    <div v-if="questionType === 105">
      <div v-for="(item, index) in row.questionDetails.issue.fillContext" :key="index">
        <h5>{{ item.content.text }}</h5>
        <p>
          {{
            answerItems.find(aItem => {
              return aItem.optionId === item.id
            })
              ? answerItems.find(aItem => {
                  return aItem.optionId === item.id
                }).value
              : ''
          }}
        </p>
      </div>
    </div>
    <!-- 比重题 104  -->
    <div v-if="questionType === 104">
      <h4 class="">比重总和：{{ valueTotal }}/{{ row.questionDetails.issue.total_value }}</h4>
      <div class="matrix-scale" v-for="(rowItem, id) of row.questionDetails.issue.items" :key="id">
        <span v-html="transformHtml(rowItem.content.text)"></span>
        <p>{{ answerItems[id].value }}</p>
      </div>
    </div>
    <!-- 加总题 119  -->
    <div v-if="questionType === 119">
      <h4 v-if="row.questionDetails.issue.validate.open" class="">
        加总值需要{{ getConditionText(row.questionDetails.issue.validate.operator)
        }}{{ row.questionDetails.issue.validate.value }}
      </h4>
      <div class="matrix-scale" v-for="(rowItem, id) of row.questionDetails.issue.items" :key="id">
        <span v-html="transformHtml(rowItem.content.text)"></span>
        <span style="margin-left: 10px">（{{ rowItem.min }}-{{ rowItem.max }}）</span>
        <p
          v-if="
            answerItems[id].optionId &&
            !answerItems[id].value &&
            answerItems[id].value !== 0 &&
            row.questionDetails.issue.showUnknown
          "
        >
          {{ row.questionDetails.issue.unknownText }}
        </p>
        <p v-else>{{ answerItems[id].value }}</p>
      </div>
    </div>
    <!-- 表格自增 102 -->
    <div v-if="questionType === 102">
      <div class="matrix-scale" v-for="(rowItem, id) in getRows102().resRows" :key="id">
        <template v-for="(col, idx) in row.questionDetails.issue.items">
          <div class="flex" :key="idx">
            <h5 v-html="transformHtml(col.content.richText)"></h5>
            <!-- <h5 class="flex-shrink-0" style="max-width: 120px">
              {{col.content}}
              {{ col.content.text }}
            </h5> -->
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div>{{ get102Answer(rowItem, col) }}</div>
          </div>
        </template>
        <hr v-show="!(id + 1 == getRows102().resRows.length)" />
      </div>
    </div>
    <!--分类 -->
    <div v-if="questionType === 111">
      <!-- <pre>{{row}}</pre> -->
      <div v-for="(item, index) in row.questionDetails.issue.items" :key="index">
        <div class="textImg" v-html="transformHtml(item.content.richText || item.content.text)"></div>
        <div style="display: flex; align-items: center; flex-direction: column">
          <div v-for="(item1, index1) in getClaList(row)" :key="index1">
            <div
              v-if="item1.col_id == item.id"
              class="textImg"
              v-html="transformHtml(item1.content.richText || item1.content.text)"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 可下载附件 112 -->
    <Downloadable v-if="questionType === 112" :row-data="row"></Downloadable>
    <!-- 图片选择113 -->
    <div v-if="questionType === 113">
      <el-image v-if="getImg(row)" style="width: 90px" :z-index="5000" :src="getImg(row)" :preview-src-list="[getImg(row)]" />
    </div>
    <!-- 图片选择117 多选 -->
    <div v-if="questionType === 117" class="flex flex-wrap">
      <div v-for="(v, i) in answerItems" :key="i" style="display: flex; flex-direction: column; margin: 0 10px 10px 0">
        <span v-html="transformHtml(v.value)"></span>
        <el-image
          class="flex-shrink-0"
          style="width: 90px"
          :src="getImgArr(v.optionId)"
          :preview-src-list="[getImgArr(v.optionId)]"
          :z-index="5000"
        />
      </div>
    </div>
    <!-- 区块级联 114 -->
    <div v-if="questionType === 114">
      <span v-for="(item, index) in answerItems" :key="index">{{ index !== 0 ? ' / ' + item.value : item.value }}</span>
    </div>
    <!-- maxDiff题 124 -->
    <div v-if="questionType === 124">
      <div v-for="(item, index) in answerItems.filter(item=>item.colId === '2')" :key="index">
        <h5>({{index+1}}) 选项组合{{index+1}}</h5>

        <!-- 最重要 -->
        <h5>{{row.questionDetails.issue.labelBest}}</h5>
        <span class="textImg" v-html="transformHtml(worstOrBestValue(item).best)"></span>
        <!-- 最不重要 -->
        <h5>{{row.questionDetails.issue.labelWorst}}</h5>
        <span class="textImg" v-html="transformHtml(worstOrBestValue(item).worst)"></span>
        <h5>出现顺序</h5>
        <span v-for="(it, i) in maxDiffOptions(item)" :key="i">
          <span class="textImg" v-html="transformHtml(it.richText)"></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from './mixins-recycle'
import ShowFiles from './ShowFiles.vue'
import { Downloadable } from './types'
import { ellipsisMiddle } from './detailMeans.js'
import { transformHtml } from '@/components/survey-detail/utils/index.js'
import { getConditionText } from './public'

export default {
  mixins: [mixins],
  components: { ShowFiles, Downloadable },
  props: {
    row: {
      type: Object
    },
    questionType: {
      type: Number
    },
    answerItems: {
      type: Array
    },
    isEdit: {
      type: String
    },
    getAppendItems: {
      type: Function,
      default: null
    },
    additional: {
      type: Function,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    valueTotal() {
      let total = 0
      this.questionType == 104 &&
        this.answerItems.forEach(element => {
          total += parseInt(element.value)
        })
      return total
    },
    getGroupName() {
      return function (itemId) {
        const item_groups = this.row.questionDetails.issue.item_groups
        const g =
          item_groups &&
          item_groups.find(item => {
            return item.item_ids.includes(itemId)
          })
        return (g && g.title) || ''
      }
    },
    maxDiffOptions() {
      return function(item) {
        const optionIds = item.optionId.split(',')
        // const values = item.value.split(',')
        return optionIds.map( item  => ({
          optionId: item,
          // value: values[index],
          richText: this.getRichText(item)
        }))
      }
    },
    getRichText() {
      return function(optionId) {
        return this.row.questionDetails.issue.items.find(it => it.id === optionId)?.content?.richText || ''
      }
    },
    worstOrBestValue() {
      return function(item) {
        const values = this.answerItems.filter(v => v.rowId === item.rowId && v.colId!== '2')
        return {
          worst: this.getRichText(values.find(v => v.colId === '1')?.optionId),
          best: this.getRichText(values.find(v => v.colId === '0')?.optionId)
        }
      }
    }
  },
  created() {
    // console.log(this.row)
  },
  methods: {
    transformHtml,
    getConditionText,
    //分类题数据整理
    getClaList(row) {
      row.questionDetails.issue.rows.forEach((item, index) => {
        ;(row.newAnswerContentItem && row.newAnswerContentItem.length > 0 ? this.answerItems : row.items).forEach(
          (item1, index1) => {
            if (item.row_id == item1.rowId) {
              item.col_id = item1.colId
            }
          }
        )
      })
      return row.questionDetails.issue.rows
    },
    onPreview(index, type, item) {
      this.$emit('on-preview', index, type, item)
      this.additional(index)
    },
    getDownloadList(list, tag = 'url') {
      let imgList = list.map(item => {
        return this._getDownloadUrl(item[tag])
      })
      return imgList
    },
    // 单选
    getImg(row) {
      // console.log(row);
      var answerArr = ''
      if (row && row.questionDetails && row.questionDetails.issue) {
        const a = row.questionDetails.issue.items
        for (var i = 0; i < a.length; i++) {
          if (this.answerItems[0] && this.answerItems[0].optionId === a[i].id) {
            if (Array.isArray(a[i].content.image) && a[i].content.image.length !== 0) {
              answerArr = this._getDownloadUrl(a[i].content.image[0].url ? a[i].content.image[0].url : '')
            }
          }
        }
      }
      // console.log(answerArr);
      return answerArr
    },
    //除单选外 统一获取带有图片的答案的方法
    getAnswer(row, item) {
      var answerArr = []
      if (row && row.questionDetails && row.questionDetails.issue) {
        // const a = row.questionDetails.issue.items  => item
        for (var i = 0; i < this.answerItems.length; i++) {
          // let flag = false
          for (var j = 0; j < item.length; j++) {
            if (this.questionType == 2 || this.questionType == 11) {
              var issueId = this.answerItems[i].optionId
              var itemId = item[j].id
              var otherId = true
            } else if (this.questionType == 5 || this.questionType == 6) {
              if (item == row.questionDetails.issue.items) {
                var issueId = this.answerItems[i].colId
                var otherId = this.answerItems[i].rowId // temp 为了去掉多余的rowId
                var itemId = item[j].id
              } else if (item == row.questionDetails.issue.rows) {
                var issueId = this.answerItems[i].rowId
                var otherId = this.answerItems[i].colId // temp 为了去掉多余的colId
                var itemId = item[j].row_id
              }
            }
            let tipText1 = this.answerItems.filter(item => {
              if (item.value.indexOf('|') != -1) {
                return item
              }
            })
            if (issueId == itemId && otherId) {
              // 另一个id 必须有值
              // console.log(Array.isArray(a[j].content.image))
              if (Array.isArray(item[j].content.image) && item[j].content.image.length !== 0) {
                if (tipText1 && tipText1.value && tipText1.optionId && tipText1.optionId == issueId) {
                  const t = tipText1.value.split('|')[1] || ''
                  answerArr.push([
                    {
                      url: this._getDownloadUrl(item[j].content.image ? item[j].content.image[0].url : ''),
                      richText: item[j].content.richText ? item[j].content.richText + (t && ' | ' + t) : null,
                      text: item[j].content.text ? item[j].content.text + (t && ' | ' + t) : null,
                      id: issueId
                    }
                  ])
                } else {
                  answerArr.push([
                    {
                      url: this._getDownloadUrl(item[j].content.image ? item[j].content.image[0].url : ''),
                      richText: item[j].content.richText ? item[j].content.richText : null,
                      text: item[j].content.text ? item[j].content.text : null,
                      id: issueId
                    }
                  ])
                }
              } else {
                if (tipText1[j] && tipText1[j].value && tipText1[j].optionId && tipText1[j].optionId == issueId) {
                  const t = tipText1[j].value.split('|')[1] || ''
                  answerArr.push([
                    {
                      richText: item[j].content.richText ? item[j].content.richText + (t && ' | ' + t) : null,
                      text: item[j].content.text ? item[j].content.text + (t && ' | ' + t) : null,
                      id: issueId
                    }
                  ])
                } else {
                  const t = this.answerItems[i].value.split('|')[1] || ''
                  answerArr.push([
                    {
                      richText: item[j].content.richText ? item[j].content.richText + (t && ' | ' + t) : null,
                      text: item[j].content.text ? item[j].content.text + (t && ' | ' + t) : null,
                      id: issueId
                    }
                  ])
                }
              }
            } else if (!issueId) {
              /* console.log(itemId); // 把rowId多余的 填为 无
                if(!flag) {
                  answerArr.push([{
                    richText: '',
                    text: '无'
                  }])
                }
                flag = true */
            }
          }
        }
      }
      return answerArr
    },
    getUrl(item) {
      const index = item.lastIndexOf('/')
      return item.slice(index + 1)
    },
    getRadioHtml(row) {
      let tipText = ''
      if (this.answerItems && this.answerItems[0] && this.answerItems[0].value) {
        tipText = this.answerItems[0].value.split('|')[1] || ''
      }
      let appendItems = this.getAppendItems(row)
      let resOptions = [...appendItems, ...row.questionDetails.issue.items]
      for (let i = 0; i < resOptions.length; i++) {
        if (resOptions[i].id == this.answerItems[0].optionId) {
          const content = resOptions[i].content
          return content.richText ? content.richText + (tipText && ' | ' + tipText) : content.text + (tipText && ' | ' + tipText)
        }
      }
    },
    isImg(url) {
      //文件路径
      var fileName = url
      //后缀获取
      let suffix = ''
      // 获取类型结果
      let result = ''
      const flieArr = fileName.split('.')
      suffix = flieArr[flieArr.length - 1]
      if (suffix != '') {
        suffix = suffix.toLocaleLowerCase()
        // 图片格式
        const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
        // 进行图片匹配
        result = imglist.find(item => item === suffix)
        if (result) {
          return true
        } else {
          return false
        }
      }
    },
    // 返回矩阵填空的显示结果
    getMatrixAnswer(rowItem, col) {
      let itemVal = this.answerItems.find(item => {
        return item.colId === col.id && item.rowId === rowItem.row_id
      })
      let value = itemVal ? itemVal.value : ''
      return value
    },
    // 表格组合的结果
    getMatrixComposeAnswer(rowItem, col) {
      let itemVals = this.answerItems.filter(item => {
        return item.colId === col.id && item.rowId === rowItem.row_id
      })
      // let value = itemVal ? itemVal.value : ''
      let value = itemVals.map(it => it.value)
      return value.join(',')
    },
    // 返回矩阵填空的显示结果
    get102Answer(rowItem, col) {
      let itemVal = this.answerItems.find(item => {
        return item.colId === col.id && item.rowId == rowItem
      })
      let value = itemVal ? itemVal.value : ''
      return value
    },
    getRows102() {
      let resRows = []
      this.answerItems.forEach(item => {
        !resRows.includes(item.rowId) && resRows.push(item.rowId)
      })
      return { resRows }
    },
    ellipsisMiddle,
    getHtml(v) {
      if (v?.optionId && !v.value) {
        const {
          row: {
            questionDetails: { issue }
          }
        } = this
        if (issue.showUnknown) {
          return this.transformHtml(issue.unknownText)
        }
      } else {
        return this.transformHtml(this.questionType == 114 ? v?.optionId : v?.value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.record-btn {
  border-radius: 0px;
  margin-left: 35px;
  position: relative;
}
.textImg {
  margin-right: 10px;
  ::v-deep p {
    line-height: 40px;
  }
  ::v-deep img {
    width: 80px;
    height: 80px;
  }
}
::v-deep .avue-crud__menu {
  display: none;
}
</style>
